unit search.controller;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, Vcl.Controls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCGridCell, VCL.TMSFNCGridOptions, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCCustomGrid, VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid, WEBLib.DB,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Buttons, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCDataGrid;

type
  TfrmSearchController = class(TForm)
    wsbMain: TScrollBox;
    wpMain: TPanel;
    wcSearch: TXDataWebClient;
    qSearch: TXDataWebDataSet;
    dsSearch: TDataSource;
    WebLabel1: TLabel;
    WebPanel1: TPanel;
    btnBack: TSpeedButton;
    btnSelect: TSpeedButton;
    weSearch: TEdit;
    qSearchNo: TStringField;
    qSearchName: TStringField;
    dgSearch: TTMSFNCDataGrid;
    dgdbaController: TTMSFNCDataGridDatabaseAdapter;
    procedure btnBackClick(Sender: TObject);
    procedure btnSelectClick(Sender: TObject);
    procedure weSearchChange(Sender: TObject);
    procedure gSearchClick(Sender: TObject);
    procedure dgSearchCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
    Procedure LoadController;
  public
    { Public declarations }
    bSuspended : Boolean ;
    sCode,
    sName : String;
    procedure GetData;
  protected procedure LoadDFMValues; override; end;

var
  frmSearchController: TfrmSearchController;

implementation

{$R *.dfm}

uses
  stfmssystem.connection, share.common;

procedure TfrmSearchController.btnBackClick(Sender: TObject);
begin
  sCode := '';
  sName := '';
  Close;
end;

procedure TfrmSearchController.btnSelectClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmSearchController.GetData;
begin

end;

procedure TfrmSearchController.gSearchClick(Sender: TObject);
begin
  weSearch.Text := '';
  weSearch.SetFocus;
end;

procedure TfrmSearchController.LoadController;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    qSearch.Close;
    qSearch.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    qSearch.Open;
  end;
begin
  wcSearch.RawInvoke('IstfmssearchService.GetController', [bSuspended, ''], @OnResult);
  weSearch.SetFocus;
end;

procedure TfrmSearchController.WebFormShow(Sender: TObject);
begin
  LoadController;
end;

procedure TfrmSearchController.dgSearchCellClick(Sender: TObject;
  AColumn, ARow: Integer);
begin
  dgdbaController.SetActiveRecord(ARow);
  sCode := dgdbaController.FieldAtColumn[0].AsString;
  sName := dgdbaController.FieldAtColumn[1].AsString;

end;

procedure TfrmSearchController.weSearchChange(Sender: TObject);
begin
  if weSearch.Text <> '' then
    begin
      case dgSearch.Selection.StartCell.Column of
        0 : qSearch.Locate('No', weSearch.Text, [loPartialKey]);
        1 : qSearch.Locate('Name', weSearch.Text, [loPartialKey]);
      end;
    end;
end;

procedure TfrmSearchController.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wsbMain := TScrollBox.Create(Self);
  wpMain := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  btnBack := TSpeedButton.Create(Self);
  btnSelect := TSpeedButton.Create(Self);
  weSearch := TEdit.Create(Self);
  dgSearch := TTMSFNCDataGrid.Create(Self);
  dgdbaController := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcSearch := TXDataWebClient.Create(Self);
  qSearch := TXDataWebDataSet.Create(Self);
  qSearchNo := TStringField.Create(Self);
  qSearchName := TStringField.Create(Self);
  dsSearch := TDataSource.Create(Self);

  wsbMain.BeforeLoadDFMValues;
  wpMain.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  btnSelect.BeforeLoadDFMValues;
  weSearch.BeforeLoadDFMValues;
  dgSearch.BeforeLoadDFMValues;
  dgdbaController.BeforeLoadDFMValues;
  wcSearch.BeforeLoadDFMValues;
  qSearch.BeforeLoadDFMValues;
  qSearchNo.BeforeLoadDFMValues;
  qSearchName.BeforeLoadDFMValues;
  dsSearch.BeforeLoadDFMValues;
  try
    Name := 'frmSearchController';
    Width := 463;
    Height := 322;
    CSSLibrary := cssBootstrap;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    wsbMain.SetParentComponent(Self);
    wsbMain.Name := 'wsbMain';
    wsbMain.Left := 0;
    wsbMain.Top := 0;
    wsbMain.Width := 463;
    wsbMain.Height := 322;
    wsbMain.Align := alClient;
    wsbMain.AutoScroll := True;
    wsbMain.BorderStyle := bsSingle;
    wpMain.SetParentComponent(wsbMain);
    wpMain.Name := 'wpMain';
    wpMain.Left := 0;
    wpMain.Top := 0;
    wpMain.Width := 463;
    wpMain.Height := 322;
    wpMain.Align := alClient;
    wpMain.Color := clSilver;
    wpMain.TabOrder := 0;
    WebLabel1.SetParentComponent(wpMain);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 463;
    WebLabel1.Height := 32;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := 'Search Controller';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.Layout := tlCenter;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebPanel1.SetParentComponent(wpMain);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 240;
    WebPanel1.Width := 463;
    WebPanel1.Height := 82;
    WebPanel1.Align := alBottom;
    WebPanel1.ChildOrder := 2;
    WebPanel1.Color := clSilver;
    WebPanel1.TabOrder := 0;
    btnBack.SetParentComponent(WebPanel1);
    btnBack.Name := 'btnBack';
    btnBack.Left := 330;
    btnBack.Top := 38;
    btnBack.Width := 108;
    btnBack.Height := 35;
    btnBack.Caption := 'Close';
    btnBack.Color := clCrimson;
    btnBack.Font.Charset := DEFAULT_CHARSET;
    btnBack.Font.Color := clWhite;
    btnBack.Font.Height := -13;
    btnBack.Font.Name := 'Tahoma';
    btnBack.Font.Style := [fsBold];
    btnBack.HeightStyle := ssAuto;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.ParentFont := False;
    btnBack.TabOrder := 0;
    btnBack.WidthPercent := 100.000000000000000000;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnSelect.SetParentComponent(WebPanel1);
    btnSelect.Name := 'btnSelect';
    btnSelect.Left := 18;
    btnSelect.Top := 34;
    btnSelect.Width := 108;
    btnSelect.Height := 35;
    btnSelect.Caption := 'Select';
    btnSelect.Color := clGreenyellow;
    btnSelect.Font.Charset := DEFAULT_CHARSET;
    btnSelect.Font.Color := clBlack;
    btnSelect.Font.Height := -13;
    btnSelect.Font.Name := 'Tahoma';
    btnSelect.Font.Style := [fsBold];
    btnSelect.HeightStyle := ssAuto;
    btnSelect.HeightPercent := 100.000000000000000000;
    btnSelect.ParentFont := False;
    btnSelect.TabOrder := 1;
    btnSelect.WidthPercent := 100.000000000000000000;
    SetEvent(btnSelect, Self, 'OnClick', 'btnSelectClick');
    weSearch.SetParentComponent(WebPanel1);
    weSearch.Name := 'weSearch';
    weSearch.Left := 18;
    weSearch.Top := 6;
    weSearch.Width := 420;
    weSearch.Height := 22;
    weSearch.CharCase := wecUpperCase;
    weSearch.ChildOrder := 2;
    weSearch.Font.Charset := DEFAULT_CHARSET;
    weSearch.Font.Color := clWindowText;
    weSearch.Font.Height := -13;
    weSearch.Font.Name := 'Tahoma';
    weSearch.Font.Style := [];
    weSearch.HeightStyle := ssAuto;
    weSearch.HeightPercent := 100.000000000000000000;
    weSearch.ParentFont := False;
    weSearch.WidthPercent := 100.000000000000000000;
    SetEvent(weSearch, Self, 'OnChange', 'weSearchChange');
    dgSearch.SetParentComponent(wpMain);
    dgSearch.Name := 'dgSearch';
    dgSearch.Left := 0;
    dgSearch.Top := 32;
    dgSearch.Width := 463;
    dgSearch.Height := 208;
    dgSearch.Align := alClient;
    dgSearch.ParentDoubleBuffered := False;
    dgSearch.DoubleBuffered := True;
    dgSearch.TabOrder := 1;
    dgSearch.ShowAcceleratorChar := False;
    dgSearch.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgSearch.Header.VisualGrouping.Layout.Font.Height := -12;
    dgSearch.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgSearch.Header.VisualGrouping.Layout.Font.Style := [];
    dgSearch.Adapter := dgdbaController;
    dgSearch.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgSearch.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgSearch.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgSearch.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgSearch.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.BandLayout.Font.Height := -12;
    dgSearch.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.BandLayout.Font.Style := [];
    dgSearch.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.FixedLayout.Font.Height := -12;
    dgSearch.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.FixedLayout.Font.Style := [];
    dgSearch.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgSearch.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgSearch.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.FocusedLayout.Font.Height := -12;
    dgSearch.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.FocusedLayout.Font.Style := [];
    dgSearch.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.GroupLayout.Font.Height := -12;
    dgSearch.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.GroupLayout.Font.Style := [];
    dgSearch.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.NormalLayout.Font.Height := -12;
    dgSearch.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.NormalLayout.Font.Style := [];
    dgSearch.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.SelectedLayout.Font.Height := -12;
    dgSearch.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.SelectedLayout.Font.Style := [];
    dgSearch.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgSearch.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgSearch.CellAppearance.SummaryLayout.Font.Height := -12;
    dgSearch.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgSearch.CellAppearance.SummaryLayout.Font.Style := [];
    dgSearch.ColumnCount := 2;
    dgSearch.Columns.Clear;
    with dgSearch.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
    end;
    with dgSearch.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
    end;
    dgSearch.Designer := False;
    dgSearch.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgSearch.FilterAppearance.Font.Color := clWindowText;
    dgSearch.FilterAppearance.Font.Height := -12;
    dgSearch.FilterAppearance.Font.Name := 'Segoe UI';
    dgSearch.FilterAppearance.Font.Style := [];
    dgSearch.Icons.ExpandIcon.LoadFromFile('search.controller.wpMain.dgSearch.Icons.ExpandIcon.svg');
    dgSearch.Icons.CollapseIcon.LoadFromFile('search.controller.wpMain.dgSearch.Icons.CollapseIcon.svg');
    dgSearch.Icons.FilterIcon.LoadFromFile('search.controller.wpMain.dgSearch.Icons.FilterIcon.svg');
    dgSearch.Icons.FilterActiveIcon.LoadFromFile('search.controller.wpMain.dgSearch.Icons.FilterActiveIcon.svg');
    dgSearch.Icons.FilterClearIcon.LoadFromFile('search.controller.wpMain.dgSearch.Icons.FilterClearIcon.svg');
    dgSearch.Icons.FilterTypeIcon.LoadFromFile('search.controller.wpMain.dgSearch.Icons.FilterTypeIcon.svg');
    dgSearch.Icons.SortAscendingIcon.LoadFromFile('search.controller.wpMain.dgSearch.Icons.SortAscendingIcon.svg');
    dgSearch.Icons.SortDescendingIcon.LoadFromFile('search.controller.wpMain.dgSearch.Icons.SortDescendingIcon.svg');
    dgSearch.Icons.CloseIcon.LoadFromFile('search.controller.wpMain.dgSearch.Icons.CloseIcon.svg');
    SetEvent(dgSearch, Self, 'OnCellClick', 'dgSearchCellClick');
    dgSearch.RowCount := 1;
    dgdbaController.SetParentComponent(dgSearch);
    dgdbaController.Name := 'dgdbaController';
    dgdbaController.Left := 352;
    dgdbaController.Top := 96;
    dgdbaController.Width := 26;
    dgdbaController.Height := 26;
    dgdbaController.Visible := True;
    dgdbaController.Columns.Clear;
    with dgdbaController.Columns.Add do
    begin
      FieldName := 'No';
      AutoCreated := False;
    end;
    with dgdbaController.Columns.Add do
    begin
      FieldName := 'Name';
      AutoCreated := False;
    end;
    dgdbaController.DataSource := dsSearch;
    wcSearch.SetParentComponent(Self);
    wcSearch.Name := 'wcSearch';
    wcSearch.Connection := dmData.dbConnect;
    wcSearch.Left := 152;
    wcSearch.Top := 104;
    qSearch.SetParentComponent(Self);
    qSearch.Name := 'qSearch';
    qSearch.Connection := dmData.dbConnect;
    qSearch.Left := 216;
    qSearch.Top := 112;
    qSearchNo.SetParentComponent(qSearch);
    qSearchNo.Name := 'qSearchNo';
    qSearchNo.FieldName := 'No';
    qSearchNo.Size := 30;
    qSearchName.SetParentComponent(qSearch);
    qSearchName.Name := 'qSearchName';
    qSearchName.FieldName := 'Name';
    qSearchName.Size := 50;
    dsSearch.SetParentComponent(Self);
    dsSearch.Name := 'dsSearch';
    dsSearch.AutoEdit := False;
    dsSearch.DataSet := qSearch;
    dsSearch.Left := 288;
    dsSearch.Top := 120;
  finally
    wsbMain.AfterLoadDFMValues;
    wpMain.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    btnSelect.AfterLoadDFMValues;
    weSearch.AfterLoadDFMValues;
    dgSearch.AfterLoadDFMValues;
    dgdbaController.AfterLoadDFMValues;
    wcSearch.AfterLoadDFMValues;
    qSearch.AfterLoadDFMValues;
    qSearchNo.AfterLoadDFMValues;
    qSearchName.AfterLoadDFMValues;
    dsSearch.AfterLoadDFMValues;
  end;
end;

end.
